"use strict";
/**
* TelemetryEventBase.ts
* Author: CALIB http://aka.ms/CALIB
* Copyright: Microsoft 2017
*
* Holds ECS client telemetry event base
*/
Object.defineProperty(exports, "__esModule", { value: true });
var TelemetryEventBase = /** @class */ (function () {
    function TelemetryEventBase() {
    }
    TelemetryEventBase.prototype.getAttributes = function () {
        var attributes = {
            'Source': 'ecs_client'
        };
        return attributes;
    };
    return TelemetryEventBase;
}());
exports.TelemetryEventBase = TelemetryEventBase;
